<template>
    <div class="story-maker-sticker story-maker-sticker-post" @click="stickerInstance.nextStyleVariant()">
        <img class="img-change-color" :src="require('@/assets/img/instagram/ehf.png')">
        <p class="text-finish">{{ $t('dash.post-creator.story.done') }}</p>

        <div 
            :class="[
                'sticker-post' , 
                stickerInstance.data.typePost, 
                `styleVariant${stickerInstance.data.styleVariant}`, 
                stickerInstance.aspectRatio > 0.5625 ? 'containX' : 'containY'
            ]
        ">
           <div v-if="stickerInstance.data.styleVariant == 2" class="sticker-post-header">
                <img :src="stickerInstance.avatar || 'img/avatar.jpg'">
                <p>{{ stickerInstance.pageName || 'auteur' }}</p>
           </div>
            <video v-if="stickerInstance.type2 == 'video'" data-check-load :src="stickerInstance.url" :type="stickerInstance.fileType" muted playsinline loop autoplay preload="metadata" class="video media-post" onloadedmetadata="this.muted = true">
            </video>
            <img v-else class="selectDisable media-post" draggable="false" data-check-load :src="stickerInstance.url">

            <div v-if="
                stickerInstance.data.styleVariant == 2 && 
                stickerInstance.textContentIsEmpty()
            "
            class="sticker-post-footer">
                <p>
                    <span class="page-name">{{ stickerInstance.pageName || 'auteur'}}</span>
                    {{ stickerInstance.data.textContent }}
                </p>
            </div>
            <p  v-if="stickerInstance.data.styleVariant == 1" class="namePage">
                {{stickerInstance.data.typePost !== 'reel' ? '@' : ''}}{{ stickerInstance.pageName || 'auteur' }}
            </p>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            id: Number | String,
            stickerInstance: {
                type: Object,
                required: true
            }
        }
    }
</script>
